import { useState } from "react";
import HeaderSection from "../../components/HeaderSection/HeaderSection";
import BottomSection from "../../components/BottomSection/BottomSection";
import { useTheme } from "../../context/ThemeContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalculator } from "@fortawesome/free-solid-svg-icons";

const DecimalToBinary = () => {
  const [decimal, setDecimal] = useState("");
  const [binary, setBinary] = useState("");
  const { darkMode } = useTheme();

  const handleDecimalChange = (e) => {
    const value = e.target.value.replace(/\s+/g, "");
    if (/^\d*$/.test(value) || value === "") {
      setDecimal(value);
      if (value) {
        try {
          const num = parseInt(value, 10);
          if (!isNaN(num)) {
            setBinary(num.toString(2));
          } else {
            setBinary("Invalid decimal input");
          }
        } catch {
          setBinary("Invalid decimal input");
        }
      } else {
        setBinary("");
      }
    }
  };

  return (
    <>
      <HeaderSection toolId="decimalToBinary" />
      <div className="max-w-4xl mx-auto p-4 lg:max-w-full lg:px-4 dark:text-white">
        <div className="bg-white rounded-xl dark:bg-gray-800 shadow-sm dark:shadow-gray-900/10 border border-gray-200 dark:border-gray-700 overflow-hidden">
          <div className="bg-gradient-to-r from-green-500 to-green-600 p-6 text-white">
            <h1 className="text-2xl font-bold mb-2 flex items-center">
              <FontAwesomeIcon icon={faCalculator} className="mr-3" />
              Decimal to Binary Converter
            </h1>
            <p className="opacity-90">
              Convert decimal numbers to binary representation
            </p>
          </div>

          <div className="p-6">
            <label
              className="block text-gray-700 dark:text-gray-200 mb-2"
              htmlFor="decimal"
            >
              Decimal Input
            </label>
            <input
              type="text"
              id="decimal"
              value={decimal}
              onChange={handleDecimalChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter decimal number (e.g., 42)"
            />
          </div>

          <div className="p-6">
            <label
              className="block text-gray-700 dark:text-gray-200 mb-2"
              htmlFor="binary"
            >
              Binary Output
            </label>
            <textarea
              id="binary"
              value={binary}
              readOnly
              rows={2}
              className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100 dark:bg-gray-700 dark:text-gray-100"
            />
          </div>
        </div>
      </div>
      <BottomSection toolId="decimalToBinary" />
    </>
  );
};

export default DecimalToBinary;
